import { notification, Select, Spin } from "antd";
import React, { useCallback, useEffect, useReducer } from "react";

import { useQuery } from "@apollo/react-hooks";
import { CREATE_SHIPPING_OPTION } from "../../graphql/mutations/shipping-option";
import { GET_SHIPPING_OPTIONS } from "../../graphql/queries";
import { handleError, reducerFn, sleep } from "../../helper";

function ShippingOption({ value, onChange }) {
    const [state, setState] = useReducer(reducerFn, {
        options: [],
        selectedOptions: [],
        selected: value && Array.isArray(value) ? value : [],
        matchValue: {},
        search: "",
        loading: false,
    });

    const { data, refetch } = useQuery(GET_SHIPPING_OPTIONS);

    React.useEffect(() => {
        setState({ selected: value && Array.isArray(value) ? value : [] });
    }, [value]);

    useEffect(() => {
        const nodes = data?.shippingOptions || [];

        const matchValue = {};
        const options = [];
        for (let node of nodes) {
            if (!node || !node.id) continue;

            matchValue[node.id] = node;
            options.push({ value: node.id, label: node.name });
        }

        setState({ matchValue, options, selectedOptions: options });
    }, [data]);

    const handleSearch = useCallback(
        (search) => {
            const newState = { search };

            if (search) {
                let opt = [];
                if (showAdd(search, state.options)) {
                    opt = [{ value: "add-new", label: search }];
                }
                const pt = new RegExp(search, "i");
                const selectedOptions = state.options.filter(({ label }) =>
                    label.match(pt),
                );

                newState.selectedOptions = [...opt, ...selectedOptions];
            } else {
                newState.selectedOptions = state.options;
            }

            setState(newState);
        },
        [state.options],
    );

    const addShippingOption = async () => {
        const { __apolloClient__: client } = window;

        const { search } = state;

        if (!search || typeof search !== "string") return;

        setState({ loading: true });
        try {
            const { data } = await client.mutate({
                mutation: CREATE_SHIPPING_OPTION,
                variables: {
                    input: { name: search.toString() },
                },
            });

            const item = data?.createShippingOption;
            if (item) {
                const newItem = { value: item.id, label: item.name };
                const selectedOptions = [...state.options, newItem].filter(
                    (item) => item.value !== "add-new",
                );
                const options = [...state.options, newItem];
                const selected = [...state.selected, item.id].filter(
                    (item) => item.value !== "add-new",
                );

                setState({ selectedOptions, options, selected, search: "" });


                const selectValues = options.filter((item) => item?.value && selected.includes(item?.value));

                await sleep(500);
                refetch && refetch();
                if (onChange) {
                    onChange(selected, selectValues);
                }
            }

            notification.success({ message: "Add shipping option success." });
        } catch (err) {
            notification.error({ message: handleError(err.toString()) });
        } finally {
            setState({ loading: false });
        }
    };

    return state.loading ? (
        <Spin />
    ) : (
        <Select
            showSearch
            filterOption={false}
            value={state.selected}
            onSearch={handleSearch}
            mode="multiple"
            onSelect={(selected) => {
                if (!selected.includes("add-new")) {
                    return;
                }
                addShippingOption();
            }}
            onChange={(value, options) => {

                if (onChange) {
                    onChange(value, options);
                }
            }}
        >
            {state.selectedOptions.map((item) => (
                <Select.Option
                    key={item.value}
                    value={item.value}
                    className={`ddd`}
                >
                    {item.value === "add-new"
                        ? `Add: ${item.label}`
                        : item.label}
                </Select.Option>
            ))}
        </Select>
    );
}

function showAdd(search, options) {
    if (!search) return false;

    let matched = options.find(
        ({ label }) => label.toLowerCase() === search.toLowerCase(),
    );

    if (!options || !matched) return true;

    return false;
}

export { ShippingOption };
